import { useEffect } from 'react';

export function useAnalytics() {
  useEffect(() => {
    const gaId = import.meta.env.VITE_GA_ID;
    if (gaId) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      (window as any).dataLayer = (window as any).dataLayer || [];
      function gtag(...args: any[]) {
        (window as any).dataLayer.push(args);
      }
      (window as any).gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId);
    }

    const baiduId = import.meta.env.VITE_BAIDU_TONGJI_ID;
    if (baiduId) {
      (window as any)._hmt = (window as any)._hmt || [];
      const script = document.createElement('script');
      script.src = `https://hm.baidu.com/hm.js?${baiduId}`;
      document.head.appendChild(script);
    }
  }, []);
}
